import { Pipe, PipeTransform } from '@angular/core';
import {
  PRODUCT_CODE_PLACEHOLDER,
  ProductCodeCarrier,
  ProductCodeService,
} from '../services/product-code.service';

/**
 * Renders the tenant's primary product code for a product / order line, with the
 * mandatory SKU fallback (WB-7419).
 *
 *   {{ item | productCode }}          -> 'J-4471-A'  (or the SKU, or '--')
 *   {{ item | productCode:'N/A' }}    -> custom placeholder
 *
 * Deliberately **impure**. `FeatureFlagService.loadFeatures()` is called from the
 * sidebar's `ngOnInit` and from the login effect — not from a route guard
 * (`FeatureFlagGuard` is only wired to the disabled pricebook route). So on a hard
 * refresh straight onto e.g. `/quotations/123`, the `/v1/features` request races
 * the table's first render: a pure pipe would latch onto the default 'sku' and
 * never re-evaluate, silently showing the wrong identifier for the whole session.
 *
 * The cost is a string lookup per row per change-detection cycle, which is the
 * same order as the per-row method calls the dense order tables already make
 * (`getInlineMatchCode`, `isSkuMatchHighlight`, `getSemanticParsedCodes`).
 */
@Pipe({
  name: 'productCode',
  standalone: true,
  pure: false,
})
export class ProductCodePipe implements PipeTransform {
  constructor(private productCode: ProductCodeService) {}

  transform(
    product: ProductCodeCarrier | null | undefined,
    placeholder: string = PRODUCT_CODE_PLACEHOLDER
  ): string {
    return this.productCode.resolve(product, placeholder);
  }
}
